import React from "react";

export default function Headbox() {
  return <div className="audicars"></div>;
}
